import React, { memo, useState, useEffect } from 'react';
import ScenarioCard from './components/ScenarioCard';
import BreakdownList from './components/BreakdownList';
import { reportOperationLog } from '@gp/services/global';
import { ALL_REPORT_OPERATION_LOG } from '@gp/constants/operationLogParams';
import './index.scss';

interface ForecastPropsType {
  selectBO: string[],
  selectValue: {
    type: 'market' | 'region';
    regions: string[];
    markets: string[];
  };
  filterBOLoading: boolean,
  setUpdateTime: React.Dispatch<React.SetStateAction<string>> | null,
}

const DEFAULT_PROPS: ForecastPropsType = {
  selectBO: [],
  selectValue: {
    type: 'region',
    regions: [],
    markets: [],
  },
  filterBOLoading: true,
  setUpdateTime: null,
};

function Forecast(props: ForecastPropsType) {

  const {
    selectBO,
    selectValue,
    filterBOLoading,
    setUpdateTime,
  } = props;

  const [isScenarioCardAllNoData, setIsScenarioCardAllNoData] = useState<boolean>(false);

  // 页面打点
  useEffect(() => {
    reportOperationLog(ALL_REPORT_OPERATION_LOG['STUDIO_OVERALL_FINANCE_FORECAST']);
  }, []);

  return (
    <section className="dbg-studio-overall-finance-year-forecast">
      <ScenarioCard
        filterBOLoading={filterBOLoading}
        selectBO={selectBO}
        selectValue={selectValue}
        setIsScenarioCardAllNoData={setIsScenarioCardAllNoData}
        setUpdateTime={setUpdateTime}
      />
      <BreakdownList
        filterBOLoading={filterBOLoading}
        selectBO={selectBO}
        selectValue={selectValue}
        isScenarioCardAllNoData={isScenarioCardAllNoData}
      />
    </section>
  );
}

Forecast.defaultProps = DEFAULT_PROPS;

export default memo(Forecast);
